import { render } from "./B2bPageRemadvs.vue?vue&type=template&id=7022dfd8&scoped=true&lang=pug"
import script from "./B2bPageRemadvs.vue?vue&type=script&lang=js"
export * from "./B2bPageRemadvs.vue?vue&type=script&lang=js"

import "./B2bPageRemadvs.vue?vue&type=style&index=0&id=7022dfd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7022dfd8"]])

export default __exports__